import { ErrorComponentProps } from '@ferreri/minato-error-handler-react';
import {
  ModalFullScreen,
  NotFoundIllustration,
} from '@angeplus/prever-component-lib';

export const TermNotFoundError = ({
  error,
  hideError,
}: ErrorComponentProps) => {
  return (
    <ModalFullScreen
      title="Termo não localizado"
      description="Não foi possível encontrar as informações do termo. Tente novamente por favor."
      labelButtonPrimary="Tentar novamente"
      error={error}
      illustration={<NotFoundIllustration />}
      onClickButtonPrimary={() => hideError?.()}
    />
  );
};
